import React from 'react';
import { PhoneIcon, RefreshCwIcon } from 'lucide-react';
import { CONTACT } from '../../data/modalities';
export function UsedEquipment() {
  return <section id="used-equipment" className="w-full bg-slate-50 py-20 sm:py-24" data-id="element-228" data-mp="2d40oi9k5kxfu">
      <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-229" data-mp="282kzk6euu6s6">
        <div className="overflow-hidden rounded-3xl border border-slate-200 bg-white p-8 shadow-[0_20px_50px_-28px_rgba(26,27,75,0.28)] sm:p-12" data-id="element-230" data-mp="235bbau37c15x">
          <div className="grid items-center gap-10 lg:grid-cols-[0.85fr_1.15fr]" data-id="element-231" data-mp="1z50wcrxfm0ex">
            <div className="relative flex aspect-[4/3] items-center justify-center overflow-hidden rounded-2xl bg-slate-50" data-id="element-232" data-mp="1ubzeqc5ubmrn">
              <div className="absolute h-40 w-40 rounded-full border border-teal/35" data-id="element-233" data-mp="1pdxw1scbtpgp" />
              <div className="absolute h-28 w-28 rounded-full border border-navy/15" data-id="element-234" data-mp="1kg4trae59flp" />
              <span className="relative flex h-20 w-24 items-center justify-center rounded-2xl border border-navy/15 bg-white text-navy shadow-sm" data-id="element-235" data-mp="1fe71xrrohch5">
                <RefreshCwIcon className="h-9 w-9" data-id="element-236" data-mp="2j7dp5y51ped7" />
              </span>
              <span className="absolute bottom-6 text-[10px] font-semibold tracking-[0.18em] text-navy/55" data-id="element-237" data-mp="2j62mk1nc6cno">
                PRE-OWNED OPTIONS
              </span>
            </div>
            <div data-id="element-238" data-mp="29aivbsjpw259">
              <p className="text-[12px] font-semibold uppercase tracking-[0.16em] text-teal" data-id="element-239" data-mp="29b0uawxrkugv">
                Used Equipment
              </p>
              <h2 className="mt-3 font-display text-3xl font-bold leading-tight tracking-tight text-navy sm:text-[2.4rem]" data-id="element-240" data-mp="31xdb4c5ladce">
                A better conversation about pre-owned modalities
              </h2>
              <p className="mt-5 text-[16px] leading-relaxed text-charcoal/75" data-id="element-241" data-mp="2sxykncpfa2rw">
                Availability changes. JAG can help doctors source and evaluate
                pre-owned or refurbished modality options, then determine
                whether a particular system is a sensible fit for the practice.
              </p>
              <p className="mt-4 text-sm leading-relaxed text-charcoal/60" data-id="element-242" data-mp="1ll6m4soe3u2y">
                Examples may include laser, shockwave, light therapy, imaging,
                or other modality categories — based on current availability,
                not guaranteed inventory.
              </p>
              <a href={CONTACT.phoneHref} className="mt-8 inline-flex items-center gap-2 rounded-full bg-navy px-7 py-3.5 text-[15px] font-semibold text-white transition-colors hover:bg-navy/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal focus-visible:ring-offset-2" data-id="element-243" data-mp="3ef65o3kv7jsr">
                <PhoneIcon className="h-[18px] w-[18px]" data-id="element-244" data-mp="2vhmw8yuhvz5t" />
                Call About Used Equipment
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}